import axios from 'axios'
import { Axios } from '@/config/axios'

const SESSION_KEYS = ['token', 'user.id', 'user.role', 'accounts', 'didModalInstallationAppeared', 'ecpToken']

function setSession (data) {
    localStorage.setItem('token', data.token)
    localStorage.setItem('user.role', data.data.role)
    if (data.accounts) {
        localStorage.setItem('accounts', true)
    } else {
        localStorage.setItem('user.id', data.data.id)
    }
}

function clearSession () {
    SESSION_KEYS.forEach(key => localStorage.removeItem(key))
}

const api = (path) => process.env.VUE_APP_API_URL + path

const state = {
    user: null
}

const getters = {
    isAuthenticated () {
        return state.user !== null
    },
    user () {
        return state.user
    }
}

const actions = {
    login ({ commit }, data) {
        return axios.post(api('/api/admin/auth'), data)
            .then((response) => {
                setSession(response.data)
                return response.data
            })
    },

    loginPwdless ({ commit }, data) {
        return axios.post(api('/api/auth/login'), data)
            .then((response) => {
                localStorage.removeItem('ecpToken')
                return response.data
            })
    },

    loginCollab ({ commit }, data) {
        return axios.post(api('/api/auth/login-collab'), data)
            .then((response) => response.data)
    },

    loginEcp ({ commit }, data) {
        return axios.post(api('/api/auth/login-ecp'), data)
            .then((response) => {
                setSession(response.data)
                localStorage.removeItem('ecpToken')
                return response.data
            })
    },

    verify ({ commit }, data) {
        return axios.post(api('/api/auth/verify'), data)
            .then((response) => {
                localStorage.setItem('token', response.data.data.token)
                localStorage.setItem('user.id', response.data.data.user.id)
                localStorage.setItem('user.role', response.data.data.user.role)
                return response.data
            })
    },

    verifyEcp ({ commit }, data) {
        return axios.post(api('/api/auth/verify-ecp'), data)
            .then((response) => response.data)
    },

    getUserInfos ({ commit }, data) {
        return axios.post(api('/api/auth/get-user-infos'), data)
            .then((response) => response.data)
    },

    logout () {
        clearSession()
        return Axios.post('/api/auth/logout')
            .then((response) => response)
    },

    verifyPasswordToken ({ commit }, data) {
        return axios.post(api('/api/auth/verify/token'), data)
            .then((response) => response)
    },

    updatePassword ({ commit }, data) {
        return axios.post(api('/api/auth/reset'), data)
            .then((response) => response)
    },

    checkUserExists ({ commit }, data) {
        return axios.post(api('/api/auth/check-user-exists'), data)
            .then((response) => response.data)
    },

    magiclink ({ commit }, data) {
        return axios.post(`${process.env.VUE_APP_API_URL}/api/auth/magiclink/${data.url}`)
            .then((response) => response.data)
    },

    resendOtp ({ commit }, data) {
        return axios.post(api('/api/auth/resend-otp'), data)
            .then((response) => response.data)
    },

    resendOtpCollab ({ commit }, data) {
        return axios.post(api('/api/auth/resend-otp-collab'), data)
            .then((response) => response.data)
    },

    validateOtp ({ commit }, data) {
        return axios.post(api('/api/auth/validate-otp'), data)
            .then((response) => {
                if (response.data.token) {
                    setSession(response.data)
                }
                return response.data
            })
    },

    validateOtpUpdate ({ commit }, data) {
        return axios.post(api('/api/auth/validate-otp-update'), data)
            .then((response) => response.data)
    },

    validateOtpCollab ({ commit }, data) {
        return axios.post(api('/api/auth/validate-otp-collab'), data)
            .then((response) => {
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token)
                    localStorage.setItem('user.id', response.data.data.id)
                    localStorage.setItem('user.role', response.data.data.role)
                }
                return response.data
            })
    },

    getSecretQuestions ({ commit }) {
        return axios.get(api('/api/auth/get-secret-questions'))
            .then((response) => response.data)
    },

    getConfigurationInfos ({ commit }, data) {
        return axios.post(api('/api/auth/get-configuration-infos'), data)
            .then((response) => response.data)
    },

    getReverseAuth ({ commit }) {
        return axios.get(api('/api/auth/get-reverse-auth'))
            .then((response) => response.data)
    },

    storeSecretQuestions ({ commit }, data) {
        return axios.post(api('/api/auth/store-secret-questions'), data)
            .then((response) => {
                if (response.data.token) {
                    setSession(response.data)
                }
                return response.data
            })
    },

    validateSecretQuestions ({ commit }, data) {
        return axios.post(api('/api/auth/validate-secret-questions'), data)
            .then((response) => {
                if (response.data.token) {
                    setSession(response.data)
                }
                return response.data
            })
    },

    updateContact ({ commit }, data) {
        return axios.post(api('/api/auth/update-contact'), data)
            .then((response) => response.data)
    },

    saveInfos ({ commit }, data) {
        return Axios.post('/api/auth/save-infos', data)
            .then((response) => response.data)
    },

    validateOtpConfigInfos ({ commit }, data) {
        return Axios.post('/api/auth/validate-otp-config-infos', data)
            .then((response) => response.data)
    },

    resendOtpConfigInfos ({ commit }, data) {
        return Axios.post('/api/auth/resend-otp-config-infos', data)
            .then((response) => response.data)
    },
}

const mutations = {
    SET_USER (state, user) {
        state.user = user
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
